module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "text-xs-center"
  }, [_c('v-flex', [_c('v-btn', {
    ref: "repeat",
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.toggleRepeat
    }
  }, [(_vm.player.repeat === 0) ? _c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("repeat")]) : (_vm.player.repeat === 1) ? _c('v-icon', [_vm._v("repeat_one")]) : _c('v-icon', [_vm._v("repeat")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.player.playlist.length,
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.playPrevious
    }
  }, [_c('v-icon', [_vm._v("skip_previous")])], 1), _vm._v(" "), (_vm.player.state !== 1) ? _c('v-btn', {
    staticClass: "elevation-1 ml-0 mr-0",
    attrs: {
      "large": "",
      "icon": "",
      "color": "secondary",
      "dark": "",
      "disabled": !_vm.$store.getters.audio
    },
    on: {
      "click": _vm.play
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1) : _c('v-btn', {
    staticClass: "elevation-1 ml-0 mr-0",
    attrs: {
      "large": "",
      "icon": "",
      "color": "secondary",
      "dark": ""
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "disabled": !_vm.canNext,
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.playNext
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 ml-0 mr-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('toggleShuffle')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.player.shuffle ? '' : 'grey'
    }
  }, [_vm._v("shuffle")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-028aa5f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePlayer/ThePlayerControls.vue
// module id = 337
// module chunks = 0